import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Alert from 'client/components/ui/Alert/Alert';
import Modal from 'client/components/ui/Modal/Modal';
import Button from 'client/components/aria/Button/Button';

import styles from '../ClearModal.module.scss';

export const ClearModal = ({ clearModalOpen, setClearModalOpen, handleConfirm }) => {
    const intl = useIntl();
    const handleCancel = () => {
        setClearModalOpen(false);
    };

    return <Modal
        data-testid="clearModal.dialog"
        open={clearModalOpen}
    >
        <Alert data-testid="clearModal.dialog.alert">
            <h1 className="govuk-label-wrapper">
                {intl.formatMessage({ id: 'mapToolbar.clearDialog.title' })}
            </h1>
            <div className={['govuk-form-group'].join(' ')}>
                <p>{intl.formatMessage({ id: 'mapToolbar.clearDialog.body' })}</p>
                <p><em>{intl.formatMessage({ id: 'mapToolbar.clearDialog.note' })}</em></p>
                <div className={styles.actions}>
                    <Button
                        data-testid="clearModal.button.cancel"
                        variant="error"
                        onPress={handleCancel}
                    >
                        {intl.formatMessage({ id: 'general.cancel' })}
                    </Button>
                    <Button
                        data-testid="clearModal.button.confirm"
                        variant="success"
                        onPress={handleConfirm}
                    >
                        {intl.formatMessage({ id: 'yes' })}
                    </Button>
                </div>
            </div>
        </Alert>
    </Modal>;
};

ClearModal.propTypes = {
    clearModalOpen: PropTypes.bool,
    setClearModalOpen: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired
};

ClearModal.defaultProps = {
    clearModalOpen: false
};
